const reportServices = {}

reportServices.getEnrolmentReportList = async () => {
    return {
        reports: [
            {
                id: 'enrolment-list-report',
                name: 'Enrolment List Report',
                category: 'enrolment',
                description: 'This report contains sales summary info',
            },
            {
                id: 'medical-information-report',
                name: 'Medical Information Report',
                category: 'enrolment',
                description: 'Members and medical condition details for staff use',
            },
        ],
    }
}

reportServices.getPaymentReportList = async () => {
    return {
        reports: [
            {
                id: 'payment-list-report',
                name: 'Payment List Report',
                category: 'payment',
                description: 'This report includes purchase order summary information',
            },
        ],
    }
}
export default reportServices
